const lodash = require("lodash");
const { createReducer } = require("../../helpers");
const {
  ALL_ORDERS_LIST,
  ALL_ORDERS_LIST_SUCCESS,
  ALL_ORDERS_LIST_ERROR,
  ALL_ORDERS_LIST_RESET,

  TOPAY_ORDERS_LIST,
  TOPAY_ORDERS_LIST_SUCCESS,
  TOPAY_ORDERS_LIST_ERROR,
  TOPAY_ORDERS_LIST_RESET,

  TOPACK_ORDERS_LIST,
  TOPACK_ORDERS_LIST_SUCCESS,
  TOPACK_ORDERS_LIST_ERROR,
  TOPACK_ORDERS_LIST_RESET,

  TOSHIP_ORDERS_LIST,
  TOSHIP_ORDERS_LIST_SUCCESS,
  TOSHIP_ORDERS_LIST_ERROR,
  TOSHIP_ORDERS_LIST_RESET,

  TORECEIVE_ORDERS_LIST,
  TORECEIVE_ORDERS_LIST_SUCCESS,
  TORECEIVE_ORDERS_LIST_ERROR,
  TORECEIVE_ORDERS_LIST_RESET,

  TOCOMPLETE_ORDERS_LIST,
  TOCOMPLETE_ORDERS_LIST_SUCCESS,
  TOCOMPLETE_ORDERS_LIST_ERROR,
  TOCOMPLETE_ORDERS_LIST_RESET,

  RETURN_ORDERS_LIST,
  RETURN_ORDERS_LIST_SUCCESS,
  RETURN_ORDERS_LIST_ERROR,
  RETURN_ORDERS_LIST_RESET,

  CANCEL_ORDERS,
  CANCEL_ORDERS_SUCCESS,
  CANCEL_ORDERS_RESET,
  CANCEL_ORDERS_ERROR,

  GET_ORDER_DETAILS,
  GET_ORDER_DETAILS_SUCCESS,
  GET_ORDER_DETAILS_RESET,
  GET_ORDER_DETAILS_ERROR,

  CANCEL_THE_ORDER,
  CANCEL_THE_ORDER_SUCCESS,
  CANCEL_THE_ORDER_ERROR,
  CANCEL_THE_ORDER_RESET,

  RECEIVED_ORDERS,
  RECEIVED_ORDERS_SUCCESS,
  RECEIVED_ORDERS_ERROR,
  RECEIVED_ORDERS_RESET,

  TO_ACCEPT_ORDERS_LIST,
  TO_ACCEPT_ORDERS_LIST_SUCCESS,
  TO_ACCEPT_ORDERS_LIST_ERROR,
  TO_ACCEPT_ORDERS_LIST_RESET,

  TO_REDEEM_ORDERS_LIST,
  TO_REDEEM_ORDERS_LIST_SUCCESS,
  TO_REDEEM_ORDERS_LIST_ERROR,
  TO_REDEEM_ORDERS_LIST_RESET,
} = require("./constants");

const initialState = {
  allOrders: {
    data: [],
    loading: false,
    error: false,
  },
  toShipOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toPayOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toPackOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toRecieveOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toCompleteOrders: {
    data: {},
    loading: false,
    error: false,
  },
  returnOrders: {
    data: {},
    loading: false,
    error: false,
  },
  cancelOrders: {
    data: {},
    loading: false,
    error: false,
  },
  ordersDetails: {
    data: {},
    loading: false,
    error: false,
  },
  cancelTheOrders: {
    data: {},
    loading: false,
    error: false,
  },
  recievedOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toAcceptOrders: {
    data: {},
    loading: false,
    error: false,
  },
  toRedeemOrders: {
    data: {},
    loading: false,
    error: false,
  },
};

module.exports = createReducer(
  {
    ///---------------------- LIST ORDERS ---------------------------///
    [ALL_ORDERS_LIST]: (draft) => ({
      allOrders: {
        ...draft.allOrders,
        loading: true,
      },
    }),
    [ALL_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      allOrders: {
        ...draft.allOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [ALL_ORDERS_LIST_ERROR]: (draft, action) => ({
      allOrders: {
        ...draft.allOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [ALL_ORDERS_LIST_RESET]: () => ({
      allOrders: { ...initialState.allOrders },
    }),
    ///---------------------- GET ORDERS -------------------------///
    [TOSHIP_ORDERS_LIST]: (draft) => ({
      toShipOrders: {
        ...draft.toShipOrders,
        loading: true,
      },
    }),
    [TOSHIP_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toShipOrders: {
        ...draft.toShipOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TOSHIP_ORDERS_LIST_ERROR]: (draft, action) => ({
      toShipOrders: {
        ...draft.toShipOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TOSHIP_ORDERS_LIST_RESET]: () => ({
      toShipOrders: { ...initialState.toShipOrders },
    }),
    ///----------------------- CANCEL ORDERS -----------------------///
    [CANCEL_ORDERS]: (draft) => ({
      cancelOrders: {
        ...draft.cancelOrders,
        loading: true,
      },
    }),
    [CANCEL_ORDERS_SUCCESS]: (draft, action) => ({
      cancelOrders: {
        ...draft.cancelOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CANCEL_ORDERS_ERROR]: (draft, action) => ({
      cancelOrders: {
        ...draft.cancelOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CANCEL_ORDERS_RESET]: () => ({
      cancelOrders: { ...initialState.cancelOrders },
    }),
    ///----------------------- RECEIVED ORDERS -----------------------///
    [TOPAY_ORDERS_LIST]: (draft) => ({
      toPayOrders: {
        ...draft.toPayOrders,
        loading: true,
      },
    }),
    [TOPAY_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toPayOrders: {
        ...draft.toPayOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TOPAY_ORDERS_LIST_ERROR]: (draft, action) => ({
      toPayOrders: {
        ...draft.toPayOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TOPAY_ORDERS_LIST_RESET]: () => ({
      toPayOrders: { ...initialState.toPayOrders },
    }),

    [TOPACK_ORDERS_LIST]: (draft) => ({
      toPackOrders: {
        ...draft.toPackOrders,
        loading: true,
      },
    }),
    [TOPACK_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toPackOrders: {
        ...draft.toPackOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TOPACK_ORDERS_LIST_ERROR]: (draft, action) => ({
      toPackOrders: {
        ...draft.toPackOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TOPACK_ORDERS_LIST_RESET]: () => ({
      toPackOrders: { ...initialState.toPackOrders },
    }),

    [TORECEIVE_ORDERS_LIST]: (draft) => ({
      toRecieveOrders: {
        ...draft.toRecieveOrders,
        loading: true,
      },
    }),
    [TORECEIVE_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toRecieveOrders: {
        ...draft.toRecieveOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TORECEIVE_ORDERS_LIST_ERROR]: (draft, action) => ({
      toRecieveOrders: {
        ...draft.toRecieveOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TORECEIVE_ORDERS_LIST_RESET]: () => ({
      toRecieveOrders: { ...initialState.toRecieveOrders },
    }),

    [TOCOMPLETE_ORDERS_LIST]: (draft) => ({
      toCompleteOrders: {
        ...draft.toCompleteOrders,
        loading: true,
      },
    }),
    [TOCOMPLETE_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toCompleteOrders: {
        ...draft.toCompleteOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TOCOMPLETE_ORDERS_LIST_ERROR]: (draft, action) => ({
      toCompleteOrders: {
        ...draft.toCompleteOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TOCOMPLETE_ORDERS_LIST_RESET]: () => ({
      toCompleteOrders: { ...initialState.toCompleteOrders },
    }),

    [RETURN_ORDERS_LIST]: (draft) => ({
      returnOrders: {
        ...draft.returnOrders,
        loading: true,
      },
    }),
    [RETURN_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      returnOrders: {
        ...draft.returnOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [RETURN_ORDERS_LIST_ERROR]: (draft, action) => ({
      returnOrders: {
        ...draft.returnOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [RETURN_ORDERS_LIST_RESET]: () => ({
      returnOrders: { ...initialState.returnOrders },
    }),

    [GET_ORDER_DETAILS]: (draft) => ({
      ordersDetails: {
        ...draft.ordersDetails,
        loading: true,
      },
    }),
    [GET_ORDER_DETAILS_SUCCESS]: (draft, action) => ({
      ordersDetails: {
        ...draft.ordersDetails,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_ORDER_DETAILS_ERROR]: (draft, action) => ({
      ordersDetails: {
        ...draft.ordersDetails,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_ORDER_DETAILS_RESET]: () => ({
      ordersDetails: { ...initialState.ordersDetails },
    }),

    [CANCEL_THE_ORDER]: (draft) => ({
      cancelTheOrders: {
        ...draft.cancelTheOrders,
        loading: true,
      },
    }),
    [CANCEL_THE_ORDER_SUCCESS]: (draft, action) => ({
      cancelTheOrders: {
        ...draft.cancelTheOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CANCEL_THE_ORDER_ERROR]: (draft, action) => ({
      cancelTheOrders: {
        ...draft.cancelTheOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CANCEL_THE_ORDER_RESET]: () => ({
      cancelTheOrders: { ...initialState.cancelTheOrders },
    }),

    [RECEIVED_ORDERS]: (draft) => ({
      recievedOrders: {
        ...draft.recievedOrders,
        loading: true,
      },
    }),
    [RECEIVED_ORDERS_SUCCESS]: (draft, action) => ({
      recievedOrders: {
        ...draft.recievedOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [RECEIVED_ORDERS_ERROR]: (draft, action) => ({
      recievedOrders: {
        ...draft.recievedOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [RECEIVED_ORDERS_RESET]: () => ({
      recievedOrders: { ...initialState.recievedOrders },
    }),

    [TO_ACCEPT_ORDERS_LIST]: (draft) => ({
      toAcceptOrders: {
        ...draft.toAcceptOrders,
        loading: true,
      },
    }),
    [TO_ACCEPT_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toAcceptOrders: {
        ...draft.toAcceptOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TO_ACCEPT_ORDERS_LIST_ERROR]: (draft, action) => ({
      toAcceptOrders: {
        ...draft.toAcceptOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TO_ACCEPT_ORDERS_LIST]: () => ({
      toAcceptOrders: { ...initialState.toAcceptOrders },
    }),

    [TO_REDEEM_ORDERS_LIST]: (draft) => ({
      toRedeemOrders: {
        ...draft.toRedeemOrders,
        loading: true,
      },
    }),
    [TO_REDEEM_ORDERS_LIST_SUCCESS]: (draft, action) => ({
      toRedeemOrders: {
        ...draft.toRedeemOrders,
        loading: false,
        data: action.payload.data,
      },
    }),
    [TO_REDEEM_ORDERS_LIST_ERROR]: (draft, action) => ({
      toRedeemOrders: {
        ...draft.toRedeemOrders,
        loading: false,
        error: action.payload.error,
      },
    }),
    [TO_REDEEM_ORDERS_LIST_RESET]: () => ({
      toRedeemOrders: { ...initialState.toRedeemOrders },
    }),
  },
  initialState
);
